import { render, staticRenderFns } from "./quantu2.vue?vue&type=template&id=5d67409c&scoped=true&"
import script from "./quantu2.vue?vue&type=script&lang=js&"
export * from "./quantu2.vue?vue&type=script&lang=js&"
import style0 from "./quantu2.vue?vue&type=style&index=0&id=5d67409c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67409c",
  null
  
)

export default component.exports